import React from "react";

const ProjectsContext = React.createContext({
  projects: "",
  setProjects: () => {}
});

export default ProjectsContext;